module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showRoute) ? _c('div', [_c('left-nav', {
    staticClass: "left-nav"
  }), _vm._v(" "), _c('app-header', {
    staticClass: "header",
    attrs: {
      "packageInfo": this.packageInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('router-view')], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d15962d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/console.vue
// module id = 552
// module chunks = 4 5 6